<template>
	<div class="content">
		<div class="content_head">

			<select v-model="areaID" v-if="$store.state.user.UserType==0" @change="selectArea">
				<option v-for="(i,index) in $store.state.area" :value="i.areaID">{{i.areaName}}</option>
			</select>

			<select v-model="ShopID" title="选择店铺" @change="getData()"
				v-if="$store.state.user.UserType<=1 && $store.state.user.ShopType<=1">
				<option v-for="i in Shop" :value="i.ShopID">
					{{i.ShopName}}
				</option>
			</select>
			<select v-model="UserState" title="用户状态" @change="getData()">
				<option v-for="i in userStae" :value="i.id">
					{{i.text}}
				</option>
			</select>
			<button type="button" class="button add" @click="Edit='add'">+新增</button>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>账号</th>
						<th>姓名</th>
						<th>手机号</th>
						<th>类型</th>
						<th>状态</th>
						<th>编辑</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in users">
						<td>
							{{index+1}}
						</td>
						<td>
							{{i.UserAccount}}
						</td>
						<td>
							{{i.UserName}}
						</td>
						<td>
							{{i.UserPhone}}
						</td>
						<td>
							{{i.UserType |UserType}}
						</td>
						<td>
							{{i.UserState | UserState}}
						</td>
						<td>
							<button type="button" class="button" @click='updateUsers(i)'>
								编辑
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="edit" v-show="Edit!=''">
			<div>
				<p>
					<label>
						<span class="red">*</span>账号:
						<input type="text" v-model="UserAccount" placeholder="请输入6-16位账号" />
						<span class="err">{{$uil.checkstr(UserAccount,6,16)?'':'×'}}</span>
					</label>
				</p>
				<p>
					<label>
						<span class="red">*</span>密码:
						<input type="text" v-model="UserPassWorld" placeholder="请输入6-16位密码" />
						<span class="err">{{$uil.checkstr(UserPassWorld,6,16)?'':'×'}}</span>
					</label>
				</p>
				<p>
					<label>
						<span class="red">*</span>姓名:
						<input type="text" v-model="UserName" placeholder="请输入用户名2-5位汉字" />
						<span class="err">{{$uil.checkchinese(UserName,2,5)?'':'×'}}</span>
					</label>
				</p>
				<p>
					<label>
						<span class="red">*</span>手机:
						<input type="text" v-model="UserPhone" placeholder="请输入用户手机号" />
						<span class="err">{{$uil.checkPhone(UserPhone)?'':'×'}}</span>
					</label>
				</p>
				<p>
					<label>
						<span class="red">*</span>店铺:
						<select v-model="ShopID" title="选择店铺" @change="getData()"
							:disabled="$store.state.user.UserType!=0">
							<option v-for="i in Shop" :value="i.ShopID">
								{{i.ShopName}}
							</option>
						</select>

					</label>
				</p>
				<p>
					<label>
						<span class="red">*</span>类型:
						<select v-model="UserType" title="请选择用户类型" @change="getData()">
							<option v-for="i in userType" :value="i.id" v-if="i.id>=$store.state.user.UserType">
								{{i.text}}
							</option>
						</select>

					</label>
				</p>
				<p>
					<label>
						<span class="red">*</span>状态:
						<select v-model="UserState" title="用户状态" @change="getData()">
							<option v-for="i in userStae" :value="i.id">
								{{i.text}}
							</option>
						</select>

					</label>
				</p>
				<p>
					<button class="button" :class="{'disabled':!checkUser}" :disabled="!checkUser"
						@click="editUsers">{{Edit=='add'? '添加':'修改'}}</button>
					<button class="button" @click="cancel">取消</button>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import j from './index.js'
	export default j
</script>

<style>
</style>
